import { Component, EventEmitter, Input, Output } from '@angular/core';
import { buttonSize, ButtonSize, buttonVariant, ButtonVariant } from '@models/button-options.enum';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.css'],
    standalone: false,
})
export class Button {
    @Input() text!: string;
    @Input() type: string = 'button';
    @Input() size: ButtonSize = buttonSize.medium;
    @Input() variant: ButtonVariant = buttonVariant.contained;
    @Input() disable: boolean = false;
    @Input() noneButtonPadding: boolean = false;

    @Input() iconButton: boolean = false;
    @Input() icon!: string;
    @Input() noneHover: boolean = false;
    @Input() noneMarginIcon: boolean = false;
    @Input() iconSize: string = '24px';

    @Input() customFontSize!: string;
    @Input() customFontColor!: string;
    @Input() customFontWeight!: string;
    @Input() customFontFamily!: string;

    @Input() translateParams?: Record<string, any>;

    @Input() customBorderColor: string = 'var(--primary)';

    @Output() onClick = new EventEmitter();

    buttonClick(event: MouseEvent) {
        if (!this.disable) this.onClick.emit();
    }
}
